import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/audit';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const cycle = (delay: number) => {
      timeout = window.setTimeout(() => {
        setIndex(i => (i + 1) % purchaseNotifications.length);
        setVisible(true);
        timeout = window.setTimeout(() => {
          setVisible(false);
          cycle(9000 + Math.random() * 7000);
        }, 5000);
      }, delay);
    };
    cycle(7000);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  const item = purchaseNotifications[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 z-40 sm:bottom-28 sm:left-5" data-id="element-264" data-mp="1gxvucql1tn57">
      <AnimatePresence data-id="element-265" data-mp="164xsl9np7aqd">
        {visible && !dismissed && <motion.div initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[290px] items-start gap-3 rounded-2xl bg-white p-3.5 shadow-[0_16px_40px_-12px_rgba(11,27,47,0.45)] ring-1 ring-navy-900/10 sm:w-[330px]" role="status" data-id="element-266" data-mp="1175zicbbhikl">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy-900" data-id="element-267" data-mp="iaeloiejnvnx">
              <CheckCircle2Icon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-268" data-mp="s67wnxcm7h3l" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-269" data-mp="28iwmkqrf92ra">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-270" data-mp="23ld6rmf2shx8">
                {item.name} from {item.country}
              </p>
              <p className="text-[12px] leading-snug text-navy-700/80" data-id="element-271" data-mp="2anrxhbfrdkkl">
                just got the Complex Rehab Case Audit™
              </p>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.1em] text-navy-700/50" data-id="element-272" data-mp="2kmr7axc9fm96">
                A few minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="rounded-full p-1 text-navy-700/40 transition-colors duration-150 ease-out hover:bg-cream-100 hover:text-navy-900" data-id="element-273" data-mp="2pl2fz4qtjqpt">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-274" data-mp="21uyf3550m52i" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}